        <!-- <div id="pdf-container"></div> -->
                <!-- <iframe [src]="getSafeUrl(variableTemporal)" width="100%" height="600"></iframe> -->
<object [data]="getSafeUrl(base64)" type="application/pdf" width="100%" height="600"></object>
<!-- {{base64}} -->
                <!-- <object [data]="getSafeUrl(variableTemporal)" type="application/pdf" width="100%" height="600"></object> -->
        <!-- <iframe [src]="pdfSrcMBLDoc" width="350px" height="350px"></iframe> -->